import {ValidationType} from './ValidationType'

export const EmailsValidation = {
  ID: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  Description: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: true,
    maxLength: 75,
    maxValue: 0
  },
  Subject: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 255,
    maxValue: 0
  },
  Body: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  HTMLFileName: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 255,
    maxValue: 0
  },
  FromEmail: {
    validationType: ValidationType.Email,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  CC: {
    validationType: ValidationType.Email,
    isRequired: false,
    maxLength: 100,
    maxValue: 0
  },
  BCC: {
    validationType: ValidationType.Email,
    isRequired: false,
    maxLength: 100,
    maxValue: 0
  },
  EmailSignatureID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  TypeID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  NewPropertiesOnly: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  AutoAttachDocumentID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  SaveAsCorrespondence: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  FollowUpTaskInterval: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  FollowUpTaskPriority: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  MailshotGroupID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  ContentTypeID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ShowOnClientLogin: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  InActive: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  LegacyAttachments: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  }
};
